import React, { FC } from 'react';
import { CardBrand, PaymentGateway } from '../../shared/orders/model';
import { useTranslation } from '../translations';

export const cardBrands: Record<string, string> = {
  amex: 'American Express',
  diners: 'Diners Club',
  discover: 'Discover',
  giftcard: 'Gift Card',
  jcb: 'JCB',
  mastercard: 'MasterCard',
  unionpay: 'Union Pay',
  unknown: 'Unknown Card',
  visa: 'Visa',
};

export const PaymentInfo: FC<{
  readonly gateway: PaymentGateway;
  readonly cardBrand: CardBrand | null;
  readonly cardLast4: string;
}> = ({ cardBrand, cardLast4, gateway }) => {
  const { ts } = useTranslation();
  switch (gateway) {
    case 'card': {
      return ts('payment_info.card_manual');
    }

    case 'cash': {
      return ts('payment_info.cash');
    }

    case 'paypal': {
      return ts('payment_info.paypal');
    }

    case 'external': {
      if (cardBrand && cardLast4) {
        return (
          <>
            {/*  eslint-disable-next-line react/jsx-no-literals */}
            {cardBrands[cardBrand]} <small>(**** {cardLast4})</small>
          </>
        );
      }

      return ts('payment_info.credit_card');
    }

    case 'voucher': {
      return ts('payment_info.voucher');
    }

    case 'writeoff': {
      return ts('payment_info.manual_payment');
    }

    case 'pagseguro': {
      return <>PagSeguro</>;
    }

    default: {
      return ts('common.unknown');
    }
  }
};
